// extracted by mini-css-extract-plugin
export default {"notesTrigger":"styles_notesTrigger__hpLkr","pricingNotes":"styles_pricingNotes__cBlzY","emptyPlaceholder":"styles_emptyPlaceholder__gBlU+"};